"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TerraformingMission = void 0;
const PreludeCard_1 = require("../../prelude/PreludeCard");
const CardName_1 = require("../../../CardName");
const Resources_1 = require("../../../Resources");
const CardRenderer_1 = require("../../render/CardRenderer");
const SelectHowToPayDeferred_1 = require("../../../deferredActions/SelectHowToPayDeferred");
const PlaceOceanTile_1 = require("../../../deferredActions/PlaceOceanTile");
class TerraformingMission extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.TERRAFORMING_MISSION,
            metadata: {
                cardNumber: 'Y29',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.oceans(1);
                    b.plants(8).heat(8);
                    b.megacredits(-12);
                }),
                description: 'Place an ocean tile. Gain 8 plants and 8 heat. Pay 12 M€.',
            },
        });
    }
    play(player) {
        player.addResource(Resources_1.Resources.PLANTS, 8);
        player.addResource(Resources_1.Resources.HEAT, 8);
        player.game.defer(new PlaceOceanTile_1.PlaceOceanTile(player));
        player.game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(player, 12));
        return undefined;
    }
}
exports.TerraformingMission = TerraformingMission;
//# sourceMappingURL=TerraformingMission.js.map